<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { text: $t('dashboardVue.dashboard'), link: 'welcome' },
        { text: 'Məhsul', link: `/dashboard/product/${product.id}` },
        { text: 'Məhsulu redaktə et', link: '', active: true }
      ]"
      :product="product"
    />
    <!-- Container-fluid starts-->
    <div
      class="container mt-4"
      style="max-width: 1700px"
    >
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="updateProduct">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <!-- Left column content -->
                    <div class="form-group">
                      <label for="company">Təklif edən şirkət</label>
                      <input
                        v-model="product.company.name"
                        type="text"
                        class="form-control"
                        readonly
                      >
                    </div>
                    <div class="form-group">
                      <label for="name">Məhsulun adı</label>
                      <input
                        v-model="product.name"
                        type="text"
                        class="form-control"
                        required
                      >
                    </div>
                    <div class="form-group row">
                      <label
                        for="keywords"
                        class="col-sm-2 col-form-label"
                      >Açar sözlər</label>
                      <div class="col-sm-10">
                        <input
                          id="keywords"
                          v-model="newKeyword"
                          type="text"
                          class="form-control"
                          placeholder="Açar söz daxil edin və Enter'ə basın"
                          @keyup.enter="addKeyword"
                        >
                        <div class="keyword-container mt-2">
                          <span
                            v-for="(keyword, index) in product.keywords"
                            :key="index"
                            class="keyword-badge"
                          >
                            <input
                              v-model="product.keywords[index]"
                              @blur="updateKeyword(index)"
                              @keyup.enter="$event.target.blur()"
                            >
                            <button
                              type="button"
                              class="keyword-close"
                              @click="removeKeyword(index)"
                            >
                              &times;
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="description">Məhsul haqqında məlumat</label>
                      <textarea
                        v-model="product.description"
                        class="form-control"
                        rows="3"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="productType">Məhsulun tipi</label>
                      <select
                        v-model="product.type"
                        class="form-control"
                        required
                      >
                        <option value="PRODUCT">
                          Məhsul
                        </option>
                        <option value="SERVICE">
                          Xidmət
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- Right column content -->
                    <div class="form-group">
                      <label for="price">Məhsulun qiyməti/Vahid</label>
                      <div class="input-group">
                        <input
                          v-model="product.price"
                          type="number"
                          class="form-control"
                          required
                        >
                        <div class="input-group-append ml-2">
                          <select
                            v-model="product.currency"
                            class="form-control"
                          >
                            <option value="AZN">
                              AZN
                            </option>
                            <option value="USD">
                              USD
                            </option>
                            <option value="EUR">
                              EUR
                            </option>
                            <option value="RUB">
                              RUBL
                            </option>
                            <option value="TRY">
                              TL
                            </option>
                          </select>
                        </div>
                        <div class="input-group-append ml-2">
                          <input
                            v-model="product.minimumOrderQuantity"
                            type="number"
                            class="form-control"
                            required
                          >
                        </div>
                        <div class="input-group-append ml-2">
                          <select
                            v-if="product.productType===1"
                            v-model="product.unit"
                            class="form-control"
                            required
                          >
                            <option
                              v-for="v in serviceUnits"
                              :key="v"
                              :value="v"
                            >
                              {{ v }}
                            </option>
                          </select>
                          
                          <select
                            v-else
                            v-model="product.unit"
                            class="form-control"
                            required
                          >
                            <option
                              v-for="v in productUnits"
                              :key="v"
                              :value="v"
                            >
                              {{ v }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    
                    <div class="form-group">
                      <label for="validDate">Qiymət təklifinin etibarlılıq müddəti</label>
                      <input
                        v-model="product.validDate"
                        type="date"
                        class="form-control"
                        required
                      >
                    </div>
                  </div>
                </div>

                <!-- Total Prices -->
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Minimum sifariş miqdarı</label>
                  <div class="col-sm-10">
                    <div
                      v-for="(order, index) in formData.minimumOrderQuantities"
                      :key="index"
                      class="row mb-2"
                    >
                      <div class="col-sm-3">
                        <label>Say</label>
                        <input
                          v-model="order.quantity"
                          type="text"
                          class="form-control"
                          placeholder="100"
                        >
                      </div>
                      <div class="col-sm-3">
                        <label>Qiymət</label>
                        <input
                          v-model="order.price"
                          type="text"
                          class="form-control"
                          placeholder="400 AZN"
                        >
                      </div>
                      <div class="col-sm-3 d-flex align-items-center">
                        <button
                          class="btn btn-danger"
                          @click.prevent="removeOrder(index)"
                        >
                          X
                        </button>
                      </div>
                    </div>
                    <button
                      class="btn btn-primary"
                      @click.prevent="addOrder"
                    >
                      +
                    </button>
                  </div>
                </div>

                <!-- Product Sector -->
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Məhsulun uyğun olduğu fəaliyyət sahələri</label>
                  <div class="col-sm-10">
                    <SelectedSectorView
                      :sectors="productSectors"
                      :parent-id="0"
                    />
                    <div class="mt-3">
                      <button
                        v-b-modal.modal-sector-selection
                        type="button"
                        class="btn btn-sm btn-primary"
                      >
                        {{ $t('companyProfile.faliyytSahsiniSein') }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Product Images -->
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Məhsul üzrə şəkillər</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div
                        v-for="(f, i) in product.fileUrls"
                        :key="f"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            v-if="isPhoto(f)"
                            target="_blank"
                            :href="getPhoto(f, '')"
                          >
                            <img
                              :src="getPhoto(f, 'thumbnailCropped')"
                              class="card-img-top"
                              :alt="$t('newRequest.requestPhoto')"
                            >
                          </a>
                          <a
                            v-else
                            target="_blank"
                            :href="getPhoto(f, '')"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteFile(i)"
                            />
                          </div>
                          <div
                            class="position-absolute bottom-0 start-0 p-2 bg-white"
                            style="z-index: 10;"
                          >
                            <input
                              v-model="product.coverPhotoUrl"
                              type="radio"
                              :value="f"
                            >
                            <label>Cover</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="product.fileUrls.length < 8"
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectPhoto"
                    >
                      <div
                        class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                        style="height: 30px"
                      >
                        <div>{{ $t('newAUCRequest.ykl') }}</div>
                      </div>
                    </div>
                    <div
                      v-if="uploadProgress > 0 && uploadProgress < 100"
                      class="progress mt-2"
                    >
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        :style="{ width: `${uploadProgress}%` }"
                      />
                    </div>
                  </div>
                </div>

                <!-- Product Documents -->
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Məhsul barədə sənədlər</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div
                        v-for="(f, i) in product.documents"
                        :key="f"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            v-if="isPhoto(f)"
                            target="_blank"
                            :href="getPhoto(f, '')"
                          >
                            <img
                              :src="getPhoto(f, 'thumbnailCropped')"
                              class="card-img-top"
                              :alt="$t('newRequest.requestPhoto')"
                            >
                          </a>
                          <a
                            v-else
                            target="_blank"
                            :href="getPhoto(f, '')"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteProductDoc(i)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="product.documents.length < 8"
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectProductDoc"
                    >
                      <div
                        class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                        style="height: 30px"
                      >
                        <div>{{ $t('newAUCRequest.ykl') }}</div>
                      </div>
                    </div>
                    <div
                      v-if="uploadProgress > 0 && uploadProgress < 100"
                      class="progress mt-2"
                    >
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        :style="{ width: `${uploadProgress}%` }"
                      />
                    </div>
                  </div>
                </div>

                <!-- Recommendation Letters -->
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Məhsul barədə reaksiya məktubu</label>
                  <div class="col-sm-10">
                    <div class="row">
                      <div
                        v-for="(f, i) in product.recommendations"
                        :key="f"
                        class="col-md-3 mb-3"
                      >
                        <div class="card position-relative">
                          <a
                            v-if="isPhoto(f)"
                            target="_blank"
                            :href="getPhoto(f, '')"
                          >
                            <img
                              :src="getPhoto(f, 'thumbnailCropped')"
                              class="card-img-top"
                              :alt="$t('newRequest.requestPhoto')"
                            >
                          </a>
                          <a
                            v-else
                            target="_blank"
                            :href="getPhoto(f, '')"
                            class="card h-100 border border-dark text-center"
                          >
                            <div class="card-body d-flex justify-content-center align-items-center">
                              {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                            </div>
                          </a>
                          <div
                            class="position-absolute top-0 end-0 p-2 bg-dark bg-opacity-75 text-white"
                            style="cursor: pointer;"
                          >
                            <feather
                              type="trash"
                              @click="deleteRecommendationLetter(i)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="product.recommendations.length < 8"
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectRecommendationLetter"
                    >
                      <div
                        class="card bg-primary h-200 text-center text-white d-flex justify-content-center align-items-center"
                        style="height: 30px"
                      >
                        <div>{{ $t('newAUCRequest.ykl') }}</div>
                      </div>
                    </div>
                    <div
                      v-if="uploadProgress > 0 && uploadProgress < 100"
                      class="progress mt-2"
                    >
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        :style="{ width: `${uploadProgress}%` }"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group text-right mt-4">
                  <button
                    type="submit"
                    class="btn btn-primary"
                  >
                    Məhsulu yenilə
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="cancelEdit"
                  >
                    Ləğv et
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Container-fluid ends-->

    <!-- Sector Selection Modal -->
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-parent-selection="3"
        :max-selection="10"
        :parent-sector="null"
        :selected="productSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>

    <!-- Hidden File Inputs -->
    <input
      id="fileInput"
      ref="file"
      type="file"
      style="display: none"
      @change="setPhoto"
    >
    <input
      id="productDocsFileInput"
      ref="docRef"
      type="file"
      style="display: none"
      @change="setProductDoc"
    >
    <input
      id="recommendationLetterFileInput"
      ref="recommendRef"
      type="file"
      style="display: none"
      @change="setRecommendationLetter"
    >
  </div>
</template>

<script>
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import {mapState} from "vuex";
import {getProductById, updateProductById} from "@/repositories/ProductDataRepository";
import {upload} from "@/repositories/GeneralDataRepository";
import {getPhoto} from "@/repositories/Utils";

export default {
  components: {
    SelectedSectorView,
    Sector_selection_modal
  },
  data() {
    return {
      product: {
        company: {},
        name: "",
        description: "",
        price: 0,
        currency: 'AZN', // Default currency
        minimumOrderQuantity: 0,
        unit: "",
        validDate: "",
        type: "PRODUCT", // Set a default type
        documents: [],
        fileUrls: [],
        recommendations: [],
        coverPhotoUrl: "",
        keywords: [],
      },
      formData: {
        minimumOrderQuantities: [] // Add this line to hold the minimum order quantities
      },
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      productSectors: [],
      uploadProgress: 0,
      validationErrors: {},
      newKeyword: ''
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    })
  },
  mounted() {
    this.getProduct();
  },
  methods: {
    getProduct() {
      const productId = this.$route.params.id;
      getProductById(this.token, productId).then(data => {
        if (data.code === 200) {
          this.product = data.product;
          this.productSectors = data.sectors;
          // Map the totalPrices from the backend to formData.minimumOrderQuantities
          this.formData.minimumOrderQuantities = Object.keys(data.product.totalPrices).map(key => ({
            quantity: key,
            price: data.product.totalPrices[key]
          }));

          this.product.keywords = this.product.keywords || [];
          if (typeof this.product.keywords === 'string') {
            this.product.keywords = this.product.keywords.split(',').map(k => k.trim());
          }

        } else {
          this.handleErrorResponse(data);
        }
      });
    },
    addKeyword() {
      if (this.newKeyword.trim() && !this.product.keywords.includes(this.newKeyword.trim())) {
        this.product.keywords.push(this.newKeyword.trim());
        this.newKeyword = '';
      }
    },
    removeKeyword(index) {
      this.product.keywords.splice(index, 1);
    },
    updateKeyword(index) {
      // Trim the keyword and remove it if it's empty
      this.product.keywords[index] = this.product.keywords[index].trim();
      if (this.product.keywords[index] === '') {
        this.removeKeyword(index);
      }
    },
    updateProduct() {
      const productId = this.$route.params.id;
      const minimumOrderQuantitiesMap = {};
      this.formData.minimumOrderQuantities.forEach(order => {
        minimumOrderQuantitiesMap[order.quantity] = parseFloat(order.price);
      });
      const updatedProduct = {
        ...this.product,
        keywords: this.product.keywords.join(', '),
        totalPrices: minimumOrderQuantitiesMap,
        productSectors: this.productSectors.map(sector => sector.id)
      };
      updateProductById(this.token, updatedProduct).then(data => {
        if (data.code === 200) {
          this.$router.push({name: "product", params: {id: productId}});
        } else {
          this.handleErrorResponse(data);
        }
      });
    },
    addOrder() {
      this.formData.minimumOrderQuantities.push({quantity: "", price: ""});
    },
    removeOrder(index) {
      this.formData.minimumOrderQuantities.splice(index, 1);
    },
    cancelEdit() {
      this.$router.push({name: "product", params: {id: this.$route.params.id}});
    },
    handleErrorResponse(data) {
      if (data.code === 403) {
        this.$router.push({
          name: "changeAccount",
          query: {next: `/dashboard/product/edit/${this.$route.params.id}`}
        });
      } else if (data.code === 404) {
        this.$swal({
          title: this.$t("general.notFound"),
          text: this.$t("general.requestNotFound"),
          icon: "error"
        }).then(() => {
          this.$router.replace({name: "welcome"});
        });
      }
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];
      if (this.product.fileUrls.length >= 8) {
        this.$swal({
          title: `Error`,
          text: this.$t("maximumPhotoLimitReached"),
          icon: 'error',
        });
        return;
      }

      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'productPhoto', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.product.fileUrls.push(response.data.path);
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.product.fileUrls.splice(index, 1);
      }
    },
    selectProductDoc() {
      window.document.getElementById('productDocsFileInput').click();
    },
    setProductDoc() {
      let currentFile = this.$refs.docRef.files[0];
      if (this.product.documents.length >= 8) {
        this.$swal({
          title: `Error`,
          text: this.$t("maximumDocumentLimitReached"),
          icon: 'error',
        });
        return;
      }
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'productDocs', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.product.documents.push(response.data.path);
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    deleteProductDoc(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.product.documents.splice(index, 1);
      }
    },
    selectRecommendationLetter() {
      window.document.getElementById('recommendationLetterFileInput').click();
    },
    setRecommendationLetter() {
      let currentFile = this.$refs.recommendRef.files[0];
      if (this.product.recommendations.length >= 8) {
        this.$swal({
          title: `Error`,
          text: this.$t("maximumDocumentLimitReached"),
          icon: 'error',
        });
        return;
      }
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        upload(this.token, 'recommendationLetters', currentFile, (event) => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then((response) => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                this.product.recommendations.push(response.data.path);
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error',
                });
              }
            })
            .catch((e) => {
              this.uploadProgress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error',
              });
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error',
        });
      }
    },
    deleteRecommendationLetter(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.product.recommendations.splice(index, 1);
      }
    },
    sectorSelected(sectors) {
      this.productSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    }
  }
};
</script>

<style scoped>
.card-img-top {
  max-height: 200px;
  object-fit: cover;
}

.card .position-absolute {
  top: 0;
  right: 0;
  cursor: pointer;
}

.keyword-badge {
  display: inline-flex;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 2px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
}

.keyword-badge input {
  border: none;
  background: transparent;
  outline: none;
  max-width: 100px;
}

.keyword-close {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 16px;
  margin-left: 4px;
}
</style>
